import React from 'react';
import 'twin.macro';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useDraggable, useDroppable } from '@dnd-kit/core';
import tw from 'twin.macro';
import { useCombinedRefs } from '@dnd-kit/utilities';

interface Props {
  onClick: () => void;
  title: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
  disabledOver?: () => boolean;
  id: string;
}

export function StackListItem(props: Props) {
  const { id, disabledOver } = props;
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data: {
      title: props.title,
      icon: props.icon,
    },
  });

  const { isOver, setNodeRef: droppableRef } = useDroppable({
    id,
    // If we drag it we don't want to drop it on itself
    disabled: !!transform,
  });
  // Combine the two refs since that component can be both draggable and droppable
  const combinedRef = useCombinedRefs(droppableRef, setNodeRef);

  const isDisabledOver = () => (disabledOver ? disabledOver() : false);
  return (
    <li
      {...listeners}
      {...attributes}
      onClick={() => props.onClick()}
      ref={combinedRef}
      css={[
        tw`flex justify-between gap-x-6 relative px-4 py-5 hover:bg-neutral-white sm:px-6 flex-grow cursor-pointer bg-white ring-1 ring-neutral-intense/5 rounded-lg sm:rounded-xl border border-transparent`,
        !isDisabledOver() && isOver && tw`ring-2 ring-brand-intense`,
        tw`hover:border-neutral-moderate cursor-pointer`,
      ]}
    >
      <div tw="flex min-w-0 gap-x-4 flex-grow items-center">
        <div>{props.icon}</div>
        <div tw="min-w-0 flex-auto flex-grow">
          <p tw="text-sm font-semibold leading-6 text-neutral-intense">
            {props.title}
          </p>
        </div>
      </div>
      <div
        onClick={e => e.stopPropagation()}
        tw="flex shrink-0 items-center gap-x-4"
      >
        {props.children || (
          <>
            <div tw="hidden sm:flex sm:flex-col sm:items-end"></div>
            <ChevronRightIcon
              tw="h-5 w-5 flex-none text-neutral-quiet"
              aria-hidden="true"
            />
          </>
        )}
      </div>
    </li>
  );
}
